import { render, staticRenderFns } from "./RelationshipsNew.vue?vue&type=template&id=545a735c&"
import script from "./RelationshipsNew.vue?vue&type=script&lang=js&"
export * from "./RelationshipsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports